export enum CurrencyType {
  RMV,
  USDC,
}
